import type { ReactNode } from 'react';
import { Play } from 'lucide-react';

export interface ProfileMediaRowProps {
  /** Text on a filled thumbnail (e.g. "DECK"); omitted = an empty play-icon thumbnail. */
  thumbLabel?: string;
  title: string;
  subtitle?: string;
  /** Right-hand link or button (View, Add link). */
  action?: ReactNode;
  /** Dashed outline: the item is missing. */
  missing?: boolean;
}

/**
 * A file or video row on a profile card (mockup pitch deck / pitch video /
 * promo video rows): 96x64 thumbnail, title and subtitle, action on the right.
 */
export function ProfileMediaRow({
  thumbLabel,
  title,
  subtitle,
  action,
  missing = false,
}: ProfileMediaRowProps) {
  return (
    <div
      className={`flex items-center gap-4 rounded-2xl p-3.5 ${missing ? 'border-slate border border-dashed' : 'border-panel-border border'}`}
    >
      {thumbLabel ? (
        <div className="bg-teal grid h-16 w-24 shrink-0 place-items-center rounded-[0.625rem] text-[0.6875rem] font-semibold tracking-[0.5px] text-white">
          {thumbLabel}
        </div>
      ) : (
        <div className="bg-divider text-subtext grid h-16 w-24 shrink-0 place-items-center rounded-[0.625rem]">
          <Play size={22} aria-hidden />
        </div>
      )}
      <div className="min-w-0 flex-1">
        <p className="text-navy truncate text-sm font-medium">{title}</p>
        {subtitle && <p className="text-subtext truncate text-xs">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
